import React, { useState, useEffect } from 'react';
import { Card, Typography, Form, Input, Button, Table, Tag, Modal, Select, InputNumber, Switch, message, Tabs, Divider, Upload, Space, Popconfirm, AutoComplete } from 'antd';
import { PlusOutlined, EditOutlined, SaveOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../services/api';

const { Title, Text } = Typography;
const { Option } = Select;

function Configuracoes() {
  const [acessosPortal, setAcessosPortal] = useState([]);
  const [modalPortal, setModalPortal] = useState(false);
  const [formPortal] = Form.useForm();
  const [clientes, setClientes] = useState([]);
  const [emailsSugeridos, setEmailsSugeridos] = useState([]);

  const carregarAcessosPortal = async () => {
    try {
      const r = await api.get('/portal/acessos');
      setAcessosPortal(r.data || []);
    } catch {}
  };

  const carregarClientesPortal = async () => {
    try {
      const r = await api.get('/clientes');
      setClientes(r.data || []);
    } catch {}
  };

  const buscarEmailsCliente = async (clienteId) => {
    try {
      const r = await api.get('/clientes/' + clienteId + '/contatos');
      const emails = r.data.filter(c => c.email).map(c => ({ label: c.nome + ' — ' + c.email, value: c.email }));
      setEmailsSugeridos(emails);
      if (emails.length === 1) formPortal.setFieldsValue({ email: emails[0].value });
    } catch { setEmailsSugeridos([]); }
  };

  const salvarAcessoPortal = async (values) => {
    try {
      await api.post('/portal/criar-acesso', values);
      message.success('Acesso criado/atualizado!');
      setModalPortal(false);
      formPortal.resetFields();
      carregarAcessosPortal();
    } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
  };

  const toggleAtivoPortal = async (id, ativo) => {
    try {
      await api.put('/portal/acessos/' + id, { ativo });
      message.success(ativo ? 'Acesso ativado!' : 'Acesso desativado!');
      carregarAcessosPortal();
    } catch { message.error('Erro ao atualizar acesso'); }
  };
  const [servicos, setServicos] = useState([]);
  const [buscaServ, setBuscaServ] = useState('');
  const [ordemServ, setOrdemServ] = useState('nome');
  const _semAc = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const servicosVisiveis = servicos
    .filter((x) => !buscaServ || _semAc(x.nome + ' ' + (x.equipamento || '')).includes(_semAc(buscaServ)))
    .slice().sort((a, b) => ordemServ === 'preco_asc' ? (parseFloat(a.valor_base) || 0) - (parseFloat(b.valor_base) || 0)
      : ordemServ === 'preco_desc' ? (parseFloat(b.valor_base) || 0) - (parseFloat(a.valor_base) || 0)
      : String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR') || String(a.equipamento || '').localeCompare(String(b.equipamento || ''), 'pt-BR'));
  const [loadingCustos, setLoadingCustos] = useState(false);
  const [modalServico, setModalServico] = useState(false);
  const [servicoEditando, setServicoEditando] = useState(null);
  const [bloqueados, setBloqueados] = useState([]);
  const [novoBloq, setNovoBloq] = useState({ termo: '', tipo: 'parcial', motivo: 'contabilidade' });
  const [padroesEmail, setPadroesEmail] = useState([]);
  const [novoPadrao, setNovoPadrao] = useState({ padrao: '', area: 'geral' });
  const carregarProspeccao = async () => {
    try {
      const [b, pe] = await Promise.all([
        api.get('/prospeccao/bloqueados'), api.get('/prospeccao/padroes')]);
      setBloqueados(b.data || []); setPadroesEmail(pe.data || []);
    } catch (e) {}
  };
  const [formCustos] = Form.useForm();
  const [formServico] = Form.useForm();

  useEffect(() => { carregarProspeccao(); carregarDados(); carregarLogo(); carregarAcessosPortal(); carregarClientesPortal(); carregarDadosPadroes(); }, []);

  const carregarDadosPadroes = async () => {
    try {
      const r = await api.get('/padroes-calibracao');
      const dados = {};
      (r.data || []).forEach(p => { dados[p.tipo] = p; });
      setDadosPadroes(dados);
      setFormPadroes(dados);
    } catch {}
  };

  const salvarDadosPadrao = async (tipo, valores) => {
    try {
      await api.post('/padroes-calibracao/' + tipo, valores);
      message.success('Dados salvos!');
      carregarDadosPadroes();
    } catch { message.error('Erro ao salvar'); }
  };

  const [logoPreview, setLogoPreview] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoMenuPreview, setLogoMenuPreview] = useState(null);
  const [uploadingLogoMenu, setUploadingLogoMenu] = useState(false);
  const [uploadingFavicon, setUploadingFavicon] = useState(false);

  const [certStatus, setCertStatus] = React.useState({ existe: false });
  const [padroes, setPadroes] = React.useState({});
  const [dadosPadroes, setDadosPadroes] = React.useState({});
  const [formPadroes, setFormPadroes] = React.useState({});
  const [categorias, setCategorias] = React.useState([]);
  const [materiais, setMateriais] = React.useState([]);
  const [materialEditando, setMaterialEditando] = React.useState(null);
  const [modalMaterial, setModalMaterial] = React.useState(false);
  const [formMaterial] = Form.useForm();
  const [modalCategoria, setModalCategoria] = React.useState(false);
  const [categoriaEditando, setCategoriaEditando] = React.useState(null);
  const [formCategoria] = Form.useForm();

  React.useEffect(() => {
    api.get('/corrosao').then(r => setCategorias(r.data)).catch(() => {});
    api.get('/materiais').then(r => setMateriais(r.data || [])).catch(() => {});
  }, []);

  const salvarCategoria = async () => {
    try {
      const vals = await formCategoria.validateFields();
      if (categoriaEditando) {
        await api.put('/corrosao/' + categoriaEditando.id, vals);
      } else {
        await api.post('/corrosao', vals);
      }
      const r = await api.get('/corrosao');
      setCategorias(r.data);
      setModalCategoria(false);
      formCategoria.resetFields();
      setCategoriaEditando(null);
      message.success('Salvo!');
    } catch (e) { message.error('Erro ao salvar'); }
  };

  const excluirCategoria = async (id) => {
    if (!window.confirm('Excluir categoria?')) return;
    await api.delete('/corrosao/' + id);
    const r = await api.get('/corrosao');
    setCategorias(r.data);
  };

  const [lotes, setLotes] = useState([]);
  const [modalLote, setModalLote] = useState(false);
  const [lote, setLote] = useState({ tipo: 'biologico', ativo: true });

  const carregarLotes = async () => {
    try { const r = await api.get('/indicadores-lotes'); setLotes(r.data || []); } catch (e) {}
  };
  useEffect(() => { carregarLotes(); }, []);

  const salvarLote = async () => {
    try {
      if (lote.id) await api.put('/indicadores-lotes/' + lote.id, lote);
      else await api.post('/indicadores-lotes', lote);
      message.success('Lote salvo');
      setModalLote(false);
      carregarLotes();
    } catch (e) { message.error('Erro ao salvar lote'); }
  };

  const campoLote = (rot, c, tipo) => (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, color: '#888' }}>{rot}</div>
      <Input type={tipo || 'text'}
        value={lote[c] == null ? '' : (tipo === 'date' ? String(lote[c]).substring(0, 10) : String(lote[c]))}
        onChange={(e) => setLote({ ...lote, [c]: e.target.value })} />
    </div>
  );

  const PADROES_CALIBRACAO = [
    { key: 'manovacuometro', label: 'Manovacuômetro', accept: '.pdf,.jpg,.png' },
    { key: 'manometro', label: 'Manômetro', accept: '.pdf,.jpg,.png' },
    { key: 'medidor_espessura', label: 'Medidor de Espessura', accept: '.pdf,.jpg,.png' },
    { key: 'termometro', label: 'Termômetro', accept: '.pdf,.jpg,.png' },
    { key: 'luximetro', label: 'Luxímetro', accept: '.pdf,.jpg,.png' },
    { key: 'incubadora', label: 'Incubadora (teste biológico e químico)', accept: '.pdf,.jpg,.png' },
  ];

  const PADROES_CONFIG = [
    { key: 'manovacuometro', label: 'Padrão: Manovacuômetro', accept: '.pdf,.jpg,.png' },
    { key: 'manometro', label: 'Padrão: Manômetro', accept: '.pdf,.jpg,.png' },
    { key: 'medidor_espessura', label: 'Padrão: Medidor de Espessura', accept: '.pdf,.jpg,.png' },
    { key: 'luximetro', label: 'Padrão: Luxímetro', accept: '.pdf,.jpg,.png' },
    { key: 'incubadora', label: 'Padrão: Incubadora', accept: '.pdf,.jpg,.png' },
    { key: 'croqui_vertical', label: 'Croqui: Vaso Vertical', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'croqui_horizontal', label: 'Croqui: Vaso Horizontal', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'croqui_esferico', label: 'Croqui: Vaso Esférico', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'croqui_cilindrico', label: 'Croqui: Vaso Cilíndrico', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'croqui_torisf', label: 'Croqui: Tampo Torisférico', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'croqui_conico', label: 'Croqui: Tampo Cônico', accept: '.pdf,.jpg,.png,.svg' },
    { key: 'tabela_nr13', label: 'Tabela de Classificação NR-13', accept: 'image/*' },
    { key: 'croqui_me', label: 'Croqui: Medição de Espessura (item 7)', accept: 'image/*' },
    { key: 'assinatura_responsavel', label: 'Assinatura do Responsável Técnico', accept: 'image/*' },
  ];

  React.useEffect(() => {
    const todosPadroes = [...PADROES_CONFIG, ...PADROES_CALIBRACAO.filter(p => !PADROES_CONFIG.find(c => c.key === p.key))];
    Promise.all(todosPadroes.map(p => 
      api.get('/upload/padrao/' + p.key + '/status').then(r => ({ key: p.key, ...r.data })).catch(() => ({ key: p.key, existe: false }))
    )).then(results => {
      const obj = {};
      results.forEach(r => { obj[r.key] = r; });
      setPadroes(obj);
    });
  }, []);

  const removerPadrao = async (tipo) => {
    if (!window.confirm('Remover este arquivo?')) return;
    try {
      await api.delete('/upload/padrao/' + tipo);
      setPadroes(prev => ({ ...prev, [tipo]: { existe: false } }));
      message.success('Arquivo removido!');
    } catch { message.error('Erro ao remover'); }
  };

  const uploadPadrao = async (tipo, file) => {
    const formData = new FormData();
    formData.append('arquivo', file);
    try {
      await api.post('/upload/padrao/' + tipo, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      const r = await api.get('/upload/padrao/' + tipo + '/status');
      setPadroes(prev => ({ ...prev, [tipo]: { ...r.data, key: tipo } }));
      message.success('Arquivo salvo!');
    } catch { message.error('Erro ao salvar arquivo'); }
    return false;
  };
  const [uploadingCert, setUploadingCert] = React.useState(false);
  const [senhaCert, setSenhaCert] = React.useState('');

  React.useEffect(() => {
    api.get('/upload/certificado/status').then(r => setCertStatus(r.data)).catch(() => {});
  }, []);

  const handleCertUpload = async (file) => {
    const formData = new FormData();
    formData.append('certificado', file);
    formData.append('senha', senhaCert);
    try {
      setUploadingCert(true);
      await api.post('/upload/certificado', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      const r = await api.get('/upload/certificado/status');
      setCertStatus(r.data);
      window._certFile = null;
      message.success('Certificado digital salvo com sucesso!');
    } catch { message.error('Erro ao salvar certificado'); }
    finally { setUploadingCert(false); }
  };

  const carregarLogo = async () => {
    try {
      const r = await api.get('/upload/logo');
      if (r.data.logo) setLogoPreview(r.data.logo);
      try {
        const r2 = await api.get('/upload/logo-menu');
        if (r2.data.logo) setLogoMenuPreview(r2.data.logo);
      } catch {}
    } catch {}
  };

  const handleFaviconUpload = async (file) => {
    try {
      setUploadingFavicon(true);
      const formData = new FormData();
      formData.append('favicon', file);
      await api.post('/upload/favicon', formData);
      message.success('Favicon atualizado! Recarregue a página para ver.');
    } catch { message.error('Erro ao fazer upload do favicon'); }
    finally { setUploadingFavicon(false); }
    return false;
  };

  const handleLogoMenuUpload = async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    try {
      setUploadingLogoMenu(true);
      await api.post('/upload/logo-menu', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      await carregarLogo();
      message.success('Logo do menu atualizada!');
    } catch { message.error('Erro ao atualizar logo do menu'); }
    finally { setUploadingLogoMenu(false); }
    return false;
  };

  const handleLogoUpload = async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    try {
      setUploadingLogo(true);
      await api.post('/upload/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      await carregarLogo();
      message.success('Logo atualizada!');
    } catch { message.error('Erro ao atualizar logo'); }
    finally { setUploadingLogo(false); }
    return false;
  };

  const carregarDados = async () => {
    try {
      const [rCustos, rServicos] = await Promise.all([api.get('/servicos/custos'), api.get('/servicos')]);
      formCustos.setFieldsValue(rCustos.data);
      setServicos(rServicos.data);
    } catch { message.error('Erro ao carregar configurações'); }
  };

  const salvarCustos = async (values) => {
    try {
      setLoadingCustos(true);
      await api.put('/servicos/custos/atualizar', values);
      message.success('Custos de referência atualizados!');
    } catch { message.error('Erro ao salvar custos'); }
    finally { setLoadingCustos(false); }
  };

  const abrirModalServico = (servico = null) => {
    setServicoEditando(servico);
    if (servico) formServico.setFieldsValue(servico);
    else formServico.resetFields();
    setModalServico(true);
  };

  const salvarServico = async (values) => {
    try {
      if (servicoEditando) { await api.put(`/servicos/${servicoEditando.id}`, values); message.success('Serviço atualizado!'); }
      else { await api.post('/servicos', values); message.success('Serviço cadastrado!'); }
      setModalServico(false);
      carregarDados();
    } catch { message.error('Erro ao salvar serviço'); }
  };

  const colunasServicos = [
    { title: 'Serviço', dataIndex: 'nome' },
    { title: 'Equipamento', dataIndex: 'equipamento', render: (v) => v || '-' },
    { title: 'Tipo', dataIndex: 'tipo', render: (v) => <Tag color={v === 'inspecao' ? 'blue' : v === 'calibracao' ? 'green' : 'default'}>{v === 'inspecao' ? 'Inspeção' : v === 'calibracao' ? 'Calibração' : 'Outros'}</Tag> },
    { title: 'Valor Base', dataIndex: 'valor_base', render: (v) => `R$ ${parseFloat(v).toFixed(2).replace('.', ',')}` },
    { title: 'Status', dataIndex: 'ativo', render: (v) => <Tag color={v ? 'success' : 'error'}>{v ? 'Ativo' : 'Inativo'}</Tag> },
    { title: 'Ações', render: (_, r) => <Button icon={<EditOutlined />} size="small" type="primary" onClick={() => abrirModalServico(r)}>Editar</Button> },
  ];

  return (
    <div>

      <Title level={4} style={{ marginBottom: 24 }}>Configurações</Title>
      <Tabs defaultActiveKey="custos">
        <Tabs.TabPane tab="Custos de Referência" key="custos">
          <Card title="Valores utilizados no cálculo automático das propostas">
            <Form form={formCustos} layout="vertical" onFinish={salvarCustos}>
              <Divider orientation="left">Custos Gerais</Divider>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                <Form.Item name="custo_km" label="Custo por km rodado (R$/km)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} step={0.01} />
                </Form.Item>
                <Form.Item name="valor_hora_homem" label="Valor hora homem (R$/hora)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="valor_art" label="Valor da ART (R$)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="valor_almoco" label="Almoço (R$/dia)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="valor_hora_estacionamento" label="Estacionamento (R$/hora)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="percentual_imposto" label="Imposto Simples Nacional (%)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} suffix="%" precision={2} min={0} max={100} />
                </Form.Item>
                <Form.Item name="endereco_origem" label="Endereço de partida (cálculo de deslocamento)"><Input placeholder="Rua, número, bairro, cidade, UF" /></Form.Item>
              </div>
              <Divider orientation="left">Custos de Viagem</Divider>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
                <Form.Item name="valor_hotel" label="Hotel (R$/diária)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="valor_alimentacao" label="Alimentação viagem (R$/dia)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
                <Form.Item name="valor_aluguel_carro" label="Aluguel de carro (R$/diária)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
                </Form.Item>
              </div>
              <div style={{ marginTop: 8, padding: '8px 12px', background: '#fff7e6', borderRadius: 8, border: '1px solid #ffd591' }}>
                <Text type="warning">⚠️ Atenção: Alterações aqui não afetam propostas já criadas.</Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loadingCustos} size="large">Salvar Custos de Referência</Button>
              </div>
            </Form>
          </Card>
        </Tabs.TabPane>

        <Tabs.TabPane tab={`Tabela de Serviços (${servicos.length})`} key="servicos">
          <Card title="Gerencie os serviços disponíveis para propostas" extra={
            <Button type="primary" icon={<PlusOutlined />} onClick={() => abrirModalServico()}>Novo Serviço</Button>
          }>
            <Space wrap style={{ marginBottom: 12 }}>
              <Input.Search allowClear placeholder="Buscar serviço ou equipamento" style={{ width: 320 }}
                value={buscaServ} onChange={(e) => setBuscaServ(e.target.value)} />
              <Select value={ordemServ} onChange={setOrdemServ} style={{ width: 230 }} options={[
                { value: 'nome', label: 'Ordenar por nome' },
                { value: 'preco_asc', label: 'Preço: menor para maior' },
                { value: 'preco_desc', label: 'Preço: maior para menor' }]} />
              {buscaServ ? <Text type="secondary">{servicosVisiveis.length} de {servicos.length}</Text> : null}
            </Space>
            <Table columns={colunasServicos} dataSource={servicosVisiveis} rowKey="id" pagination={{ pageSize: 15 }} />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Parâmetros de Corrosão" key="corrosao">
          <div style={{ padding: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <Text type="secondary">Categorias de corrosividade conforme ISO 12944-2. Usadas no cálculo de Vida Remanescente.</Text>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => { setCategoriaEditando(null); formCategoria.resetFields(); setModalCategoria(true); }}>Nova Categoria</Button>
            </div>
            <Table
              dataSource={categorias}
              rowKey="id"
              size="small"
              columns={[
                { title: 'Código', dataIndex: 'codigo', width: 80 },
                { title: 'Descrição', dataIndex: 'descricao' },
                { title: 'Taxa de Corrosão (mm/ano)', dataIndex: 'taxa_corrosao', width: 200, render: v => String(parseFloat(v).toFixed(4)).replace('.', ',') },
                { title: 'Ações', width: 100, render: (_, r) => (
                  <Space>
                    <Button size="small" icon={<EditOutlined />} onClick={() => { setCategoriaEditando(r); formCategoria.setFieldsValue(r); setModalCategoria(true); }} />
                    <Button size="small" danger onClick={() => excluirCategoria(r.id)}>×</Button>
                  </Space>
                )}
              ]}
            />
            <Modal
              title={categoriaEditando ? 'Editar Categoria' : 'Nova Categoria de Corrosão'}
              open={modalCategoria}
              onOk={salvarCategoria}
              onCancel={() => { setModalCategoria(false); setCategoriaEditando(null); formCategoria.resetFields(); }}
              okText="Salvar"
              cancelText="Cancelar"
            >
              <Form form={formCategoria} layout="vertical">
                <Form.Item name="codigo" label="Código" rules={[{ required: true }]}><Input placeholder="Ex: C3" /></Form.Item>
                <Form.Item name="descricao" label="Descrição"><Input placeholder="Ex: Média corrosividade" /></Form.Item>
                <Form.Item name="taxa_corrosao" label="Taxa de Corrosão (mm/ano)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} precision={4} decimalSeparator="," placeholder="Ex: 0,0100" />
                </Form.Item>
              </Form>
            </Modal>
            <div style={{ marginTop: 24 }}>
              <Divider orientation="left">Imagens de Referência (usadas no relatório)</Divider>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <Card size="small" title="Tabela de Corrosividade">
                  {padroes['tabela_corrosao']?.existe && (
                    <div style={{ marginBottom: 8 }}>
                      <img src={'/api/upload/padrao/tabela_corrosao/preview'} alt="Tabela" style={{ width: '100%', maxHeight: 200, objectFit: 'contain', border: '1px solid #ddd' }} onError={e => e.target.style.display='none'} />
                      <Text type="success" style={{ fontSize: 11 }}>✅ Configurada</Text>
                    </div>
                  )}
                  <Upload beforeUpload={(file) => uploadPadrao('tabela_corrosao', file)} showUploadList={false} accept="image/*">
                    <Button icon={<UploadOutlined />} size="small">{padroes['tabela_corrosao']?.existe ? 'Atualizar' : 'Upload'} Tabela</Button>
                  </Upload>
                  {padroes['tabela_corrosao']?.existe && <Button size="small" danger onClick={() => removerPadrao('tabela_corrosao')}>×</Button>}
                </Card>
                <Card size="small" title="Mapa de Corrosividade do Brasil">
                  {padroes['mapa_corrosao']?.existe && (
                    <div style={{ marginBottom: 8 }}>
                      <img src={'/api/upload/padrao/mapa_corrosao/preview'} alt="Mapa" style={{ width: '100%', maxHeight: 200, objectFit: 'contain', border: '1px solid #ddd' }} onError={e => e.target.style.display='none'} />
                      <Text type="success" style={{ fontSize: 11 }}>✅ Configurado</Text>
                    </div>
                  )}
                  <Upload beforeUpload={(file) => uploadPadrao('mapa_corrosao', file)} showUploadList={false} accept="image/*">
                    <Button icon={<UploadOutlined />} size="small">{padroes['mapa_corrosao']?.existe ? 'Atualizar' : 'Upload'} Mapa</Button>
                  </Upload>
                  {padroes['mapa_corrosao']?.existe && <Button size="small" danger onClick={() => removerPadrao('mapa_corrosao')}>×</Button>}
                </Card>
              </div>
            </div>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Padrões de Calibração" key="padroes">
          <div style={{ padding: 16 }}>
            <Text type="secondary" style={{ marginBottom: 16, display: 'block' }}>
              Gerencie os equipamentos padrão de calibração. A incerteza, o k e a resolução saem do certificado do padrão e alimentam o cálculo de incerteza de todos os laudos.
            </Text>
            {PADROES_CALIBRACAO.map(p => (
              <Card key={p.key} size="small" style={{ marginBottom: 12, border: padroes[p.key]?.existe ? '1px solid #b7eb8f' : '1px solid #ddd' }}>
                <div style={{ fontWeight: 500, marginBottom: 10 }}>{p.label}</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
                  <Form.Item label="Identificação" style={{ margin: 0 }}>
                    <Input size="small" placeholder="Ex: MA-01" value={formPadroes[p.key]?.identificacao || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], identificacao: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Marca" style={{ margin: 0 }}>
                    <Input size="small" placeholder="Ex: Wika" value={formPadroes[p.key]?.marca || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], marca: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Certificado Nº" style={{ margin: 0 }}>
                    <Input size="small" placeholder="Nº do certificado" value={formPadroes[p.key]?.certificado || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], certificado: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Calibrado por" style={{ margin: 0 }}>
                    <Input size="small" placeholder="Ex: IPEM-MG" value={formPadroes[p.key]?.calibrado_por || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], calibrado_por: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Validade" style={{ margin: 0 }}>
                    <Input size="small" type="date" value={formPadroes[p.key]?.validade?.substring(0,10) || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], validade: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Incerteza U do certificado" style={{ margin: 0 }} tooltip="Incerteza expandida que consta no certificado do padrão, na faixa em que ele é usado. Ex.: 0,3 no termômetro digital AKSO.">
                    <Input size="small" placeholder="Ex: 0,3" value={formPadroes[p.key]?.incerteza_u ?? ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], incerteza_u: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Incerteza U — vácuo" style={{ margin: 0 }} tooltip="Só para o manovacuômetro: a incerteza da faixa de vácuo, que é diferente da de pressão. Usada quando o laudo marcar calibração em vácuo.">
                    <Input size="small" placeholder="Ex: 0,006" value={formPadroes[p.key]?.incerteza_u_vacuo ?? ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], incerteza_u_vacuo: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="k do certificado" style={{ margin: 0 }} tooltip="Fator de abrangência declarado no certificado do padrão. Quase sempre 2.">
                    <Input size="small" placeholder="2" value={formPadroes[p.key]?.fator_k_cert ?? ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], fator_k_cert: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Resolução do padrão" style={{ margin: 0 }} tooltip="Menor divisão que o padrão consegue mostrar. Ex.: 0,1 °C no termômetro digital.">
                    <Input size="small" placeholder="Ex: 0,1" value={formPadroes[p.key]?.resolucao_padrao ?? ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], resolucao_padrao: e.target.value } }))} />
                  </Form.Item>
                  <Form.Item label="Unidade" style={{ margin: 0 }} tooltip="Unidade em que a incerteza e a resolução estão expressas. Ex.: °C, kgf/cm², PSI.">
                    <Input size="small" placeholder="Ex: °C" value={formPadroes[p.key]?.unidade_padrao || ''}
                      onChange={e => setFormPadroes(prev => ({ ...prev, [p.key]: { ...prev[p.key], unidade_padrao: e.target.value } }))} />
                  </Form.Item>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', gap: 4 }}>
                    {padroes[p.key]?.existe && (
                      <Button size="small" onClick={() => window.open('/api/upload/padrao/' + p.key + '/download')}>↓ Certificado</Button>
                    )}
                    <Upload beforeUpload={(file) => uploadPadrao(p.key, file)} showUploadList={false} accept={p.accept}>
                      <Button size="small" type="primary" icon={<UploadOutlined />}>{padroes[p.key]?.existe ? 'Atualizar certificado' : 'Upload certificado'}</Button>
                    </Upload>
                    {padroes[p.key]?.existe && (
                      <Button size="small" danger onClick={() => removerPadrao(p.key)}>×</Button>
                    )}
                  </div>
                  <Button size="small" type="primary" onClick={() => salvarDadosPadrao(p.key, formPadroes[p.key] || {})}>Salvar dados</Button>
                </div>
                {padroes[p.key]?.existe && (
                  <Text type="success" style={{ fontSize: 11 }}>✅ {(padroes[p.key].tamanho/1024).toFixed(0)} KB — {padroes[p.key].atualizado ? new Date(padroes[p.key].atualizado).toLocaleDateString('pt-BR') : ''}</Text>
                )}
              </Card>
            ))}
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab={`Lotes de Indicadores (${lotes.length})`} key="lotes">
          <Card title="Lotes de indicador biológico e químico usados na manutenção de autoclave"
            extra={<Button type="primary" icon={<PlusOutlined />}
              onClick={() => { setLote({ tipo: 'biologico', ativo: true }); setModalLote(true); }}>
              Novo lote</Button>}>
            <Table rowKey="id" size="small" dataSource={lotes} pagination={false}
              locale={{ emptyText: 'Nenhum lote cadastrado.' }}
              columns={[
                { title: 'Ações', width: 90, render: (_, r) => (
                  <Space size={2}>
                    <Button size="small" icon={<EditOutlined />} onClick={() => { setLote(r); setModalLote(true); }} />
                    <Popconfirm title="Excluir este lote?" okText="Excluir" cancelText="Cancelar"
                      onConfirm={async () => {
                        try { await api.delete('/indicadores-lotes/' + r.id); carregarLotes(); }
                        catch { message.error('Erro ao excluir'); }
                      }}>
                      <Button size="small" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                  </Space>
                )},
                { title: 'Tipo', dataIndex: 'tipo', width: 110,
                  render: (v) => <Tag color={v === 'biologico' ? 'green' : 'blue'}>
                    {v === 'biologico' ? 'Biológico' : 'Químico'}</Tag> },
                { title: 'Fabricante', dataIndex: 'fabricante' },
                { title: 'Produto', dataIndex: 'produto' },
                { title: 'Lote', dataIndex: 'lote', width: 160 },
                { title: 'Validade', dataIndex: 'validade', width: 110,
                  render: (v) => {
                    if (!v) return '-';
                    const dt = String(v).substring(0, 10);
                    const venceu = new Date(dt) < new Date();
                    return <Tag color={venceu ? 'red' : 'green'}>{dt.split('-').reverse().join('/')}</Tag>;
                  } },
                { title: 'Ativo', dataIndex: 'ativo', width: 80,
                  render: (v) => <Tag color={v ? 'success' : 'default'}>{v ? 'Sim' : 'Não'}</Tag> },
              ]} />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Croquis e Tabelas" key="croquis">
          <div style={{ padding: 16 }}>
            <Text type="secondary" style={{ marginBottom: 16, display: 'block' }}>
              Faça upload dos croquis dos modelos de vasos e tabelas para uso nos laudos e prontuários.
            </Text>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              {PADROES_CONFIG.filter(p => p.key.startsWith('croqui') || p.key.includes('tabela') || p.key.includes('mapa') || p.key.includes('nr13')).map(p => (
                <Card key={p.key} size="small" style={{ border: padroes[p.key]?.existe ? '1px solid #b7eb8f' : '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <Text strong style={{ fontSize: 12 }}>{p.label}</Text>
                      <br />
                      {padroes[p.key]?.existe
                        ? <Text type="success" style={{ fontSize: 11 }}>✅ {(padroes[p.key].tamanho/1024).toFixed(0)} KB</Text>
                        : <Text type="secondary" style={{ fontSize: 11 }}>Não configurado</Text>
                      }
                    </div>
                    <div style={{ display: 'flex', gap: 4 }}>
                      {padroes[p.key]?.existe && (
                        <Button size="small" onClick={() => window.open('/api/upload/padrao/' + p.key + '/download')}>↓</Button>
                      )}
                      <Upload beforeUpload={(file) => uploadPadrao(p.key, file)} showUploadList={false} accept={p.accept}>
                        <Button size="small" type="primary" icon={<UploadOutlined />}>{padroes[p.key]?.existe ? 'Atualizar' : 'Upload'}</Button>
                      </Upload>
                      {padroes[p.key]?.existe && (
                        <Button size="small" danger onClick={() => removerPadrao(p.key)}>×</Button>
                      )}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Logo e Assinatura" key="logo">
          <div style={{ padding: 16 }}>
            <Card size="small" title="Logo do Menu (fundo escuro)" style={{ marginBottom: 16 }}>
              <Space align="center">
                <div style={{ background: '#001529', padding: 12, borderRadius: 6, minWidth: 200, textAlign: 'center' }}>
                  {logoMenuPreview ? <img src={logoMenuPreview} alt="Logo Menu" style={{ maxHeight: 50, maxWidth: 160 }} /> : <span style={{ color: '#fff' }}>Sem logo</span>}
                </div>
                <Upload beforeUpload={handleLogoMenuUpload} showUploadList={false} accept="image/*,.svg">
                  <Button icon={<UploadOutlined />} loading={uploadingLogoMenu}>{logoMenuPreview ? 'Trocar Logo Menu' : 'Upload Logo Menu'}</Button>
                </Upload>
              </Space>
              <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>Use uma versão da logo com cores claras (branca/dourada) para o fundo escuro do menu lateral.</div>
            </Card>

            <Card size="small" title="Logo da Empresa" style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                <div style={{ width: 200, height: 80, border: '1px solid #ddd', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: '#fafafa' }}>
                  {logoPreview ? <img src={logoPreview} alt="Logo" style={{ maxHeight: 70, maxWidth: 190 }} /> : <Text type="secondary">Sem logo</Text>}
                </div>
                <div>
                  <Upload beforeUpload={handleLogoUpload} showUploadList={false} accept="image/*,.svg">
                    <Button icon={<UploadOutlined />} loading={uploadingLogo} type="primary">{logoPreview ? 'Trocar Logo' : 'Fazer Upload da Logo'}</Button>
                  </Upload>
                  <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>Formatos aceitos: PNG, JPG, SVG. Usada em todos os PDFs gerados pelo sistema.</div>
                </div>
              </div>
            </Card>
            <Card size="small" title="Favicon (ícone da aba do navegador)" style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                <div style={{ width: 64, height: 64, border: '1px solid #ddd', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: '#fafafa' }}>
                  <img src="/favicon.png" alt="Favicon" style={{ maxWidth: 48, maxHeight: 48 }} onError={e => e.target.style.display='none'} />
                </div>
                <div>
                  <Upload beforeUpload={handleFaviconUpload} showUploadList={false} accept="image/*,.ico">
                    <Button icon={<UploadOutlined />} loading={uploadingFavicon} type="primary">Upload Favicon</Button>
                  </Upload>
                  <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>PNG ou ICO. Aparece na aba do navegador. Após upload, faça um novo build.</div>
                </div>
              </div>
            </Card>
            <Card size="small" title="Assinatura do Responsável Técnico">
              <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
                <div style={{ width: 200, height: 80, border: '1px solid #ddd', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: '#fafafa' }}>
                  {padroes['assinatura_responsavel']?.existe ? <Text type="success">✅ Assinatura configurada</Text> : <Text type="secondary">Sem assinatura</Text>}
                </div>
                <div>
                  <Upload beforeUpload={(file) => uploadPadrao('assinatura_responsavel', file)} showUploadList={false} accept="image/*">
                    <Button icon={<UploadOutlined />} type="primary">{padroes['assinatura_responsavel']?.existe ? 'Atualizar Assinatura' : 'Upload da Assinatura'}</Button>
                  </Upload>
                  {padroes['assinatura_responsavel']?.existe && <Button size="small" danger style={{ marginLeft: 8 }} onClick={() => removerPadrao('assinatura_responsavel')}>×</Button>}
                  <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>Usada nos laudos de calibração. Fundo transparente (PNG) recomendado.</div>
                </div>
              </div>
            </Card>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Certificado Digital" key="certificado">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 500, padding: 16 }}>
            {certStatus.existe ? (
              <div style={{ padding: 12, background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8 }}>
                <Text style={{ color: 'green' }}>✅ Certificado digital configurado</Text><br />
                <Text type="secondary" style={{ fontSize: 11 }}>Atualizado em: {certStatus.atualizado ? new Date(certStatus.atualizado).toLocaleDateString('pt-BR') : '-'} | Tamanho: {certStatus.tamanho ? (certStatus.tamanho/1024).toFixed(1) + ' KB' : '-'}</Text>
              </div>
            ) : (
              <div style={{ padding: 12, background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8 }}>
                <Text style={{ color: '#d46b08' }}>⚠️ Nenhum certificado digital configurado</Text>
              </div>
            )}
            <div>
              <Text strong>Senha do certificado (.pfx):</Text>
              <Input.Password style={{ marginTop: 8 }} value={senhaCert} onChange={e => setSenhaCert(e.target.value)} placeholder="Digite a senha antes de fazer upload" />
            </div>
            <div>
              <Text strong>Arquivo do certificado:</Text>
              <div style={{ marginTop: 8 }}>
                <Upload beforeUpload={() => false} showUploadList={true} accept=".pfx,.p12" maxCount={1} onChange={(info) => { if (info.fileList.length > 0) window._certFile = info.fileList[0].originFileObj; }}>
                  <Button icon={<UploadOutlined />}>Selecionar arquivo .pfx</Button>
                </Upload>
              </div>
              <Button type="primary" loading={uploadingCert} style={{ marginTop: 12 }} onClick={async () => {
                if (!window._certFile) { message.warning('Selecione o arquivo do certificado!'); return; }
                if (!senhaCert) { message.warning('Informe a senha do certificado!'); return; }
                await handleCertUpload(window._certFile);
              }}>Salvar Certificado</Button>
              <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>O certificado A1 será usado para assinar os documentos emitidos pelo sistema.</div>
            </div>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Acesso ao Portal" key="portal">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div>
              <strong>Acessos ao Portal do Cliente</strong>
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Gerencie os logins de acesso dos clientes ao portal de documentos.</div>
            </div>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => { formPortal.resetFields(); setModalPortal(true); }}>Novo Acesso</Button>
          </div>
          <Table
            dataSource={acessosPortal}
            rowKey="id"
            size="small"
            locale={{ emptyText: 'Nenhum acesso cadastrado.' }}
            columns={[
              { title: 'Cliente', dataIndex: 'razao_social', ellipsis: true },
              { title: 'Email', dataIndex: 'email' },
              { title: 'Último acesso', dataIndex: 'ultimo_acesso', render: v => v ? new Date(v).toLocaleString('pt-BR') : 'Nunca' },
              { title: 'Status', dataIndex: 'ativo', render: v => <Tag color={v ? 'green' : 'red'}>{v ? 'Ativo' : 'Inativo'}</Tag> },
              { title: 'Ações', width: 120, render: (_, r) => (
                <Space size={4}>
                  <Switch size="small" checked={r.ativo} onChange={v => toggleAtivoPortal(r.id, v)} />
                  <Button size="small" onClick={() => { formPortal.setFieldsValue({ cliente_id: r.cliente_id, email: r.email }); setModalPortal(true); }}>Editar</Button>
                </Space>
              )},
            ]}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Resistência de Materiais" key="materiais">
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => { setMaterialEditando(null); formMaterial.resetFields(); setModalMaterial(true); }}>Novo Material</Button>
          </div>
          <Table
            dataSource={materiais}
            rowKey="id"
            size="small"
            columns={[
              { title: 'Material', dataIndex: 'nome', render: (v) => <Text strong>{v}</Text> },
              { title: 'Norma', dataIndex: 'norma', width: 120 },
              { title: 'Tensão (MPa)', dataIndex: 'tensao_mpa', width: 120, render: (v) => parseFloat(v).toFixed(1) },
              { title: 'Tensão (kgf/cm²)', width: 140, render: (_, r) => (parseFloat(r.tensao_mpa) * 10.197162).toFixed(0) },
              { title: 'Ações', width: 100, render: (_, r) => (
                <Space>
                  <Button size="small" icon={<EditOutlined />} onClick={() => { setMaterialEditando(r); formMaterial.setFieldsValue(r); setModalMaterial(true); }} />
                  <Popconfirm title="Remover?" onConfirm={async () => { await api.delete('/materiais/' + r.id); setMateriais(materiais.filter(m => m.id !== r.id)); }}><Button size="small" danger icon={<DeleteOutlined />} /></Popconfirm>
                </Space>
              )},
            ]}
          />
          <Modal title={materialEditando ? 'Editar Material' : 'Novo Material'} open={modalMaterial} onCancel={() => setModalMaterial(false)} footer={null}>
            <Form form={formMaterial} layout="vertical" onFinish={async (values) => {
              try {
                if (materialEditando) {
                  const r = await api.put('/materiais/' + materialEditando.id, values);
                  setMateriais(materiais.map(m => m.id === materialEditando.id ? r.data : m));
                } else {
                  const r = await api.post('/materiais', values);
                  setMateriais([...materiais, r.data]);
                }
                setModalMaterial(false);
                message.success('Salvo!');
              } catch { message.error('Erro ao salvar'); }
            }}>
              <Form.Item name="nome" label="Nome do Material" rules={[{ required: true }]}><Input /></Form.Item>
              <Form.Item name="norma" label="Norma (ex: UCS-23)"><Input /></Form.Item>
              <Form.Item name="tensao_mpa" label="Tensão Admissível (MPa)" rules={[{ required: true }]}><InputNumber style={{ width: '100%' }} precision={3} decimalSeparator="," /></Form.Item>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <Button onClick={() => setModalMaterial(false)}>Cancelar</Button>
                <Button type="primary" htmlType="submit">Salvar</Button>
              </div>
            </Form>
          </Modal>
        </Tabs.TabPane>
      </Tabs>

      <Modal title={servicoEditando ? 'Editar Serviço' : 'Novo Serviço'} open={modalServico} onCancel={() => setModalServico(false)} footer={null} width={600}>
        <Form form={formServico} layout="vertical" onFinish={salvarServico}>
          <Form.Item name="nome" label="Nome do Serviço" rules={[{ required: true }]}><Input placeholder="Ex: Inspeção Interna NR-13" /></Form.Item>
          <Form.Item name="equipamento" label="Equipamento"><Input placeholder="Ex: Vaso de Pressão, Caldeira..." /></Form.Item>
          <Form.Item name="tipo" label="Tipo" rules={[{ required: true }]} extra="O tipo define se o serviço recebe rateio de mobilização e ART">
            <Select>
              <Option value="inspecao">Inspeção (recebe rateio de mobilização e ART)</Option>
              <Option value="calibracao">Calibração (custo fixo)</Option>
              <Option value="outros">Outros (custo fixo)</Option>
            </Select>
          </Form.Item>
          <Form.Item name="valor_base" label="Valor Base (R$)" rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} prefix="R$" precision={2} min={0} />
          </Form.Item>
          <Form.Item name="descricao" label="Descrição (aparece na proposta)">
            <Input.TextArea rows={4} placeholder="Descreva o que está incluso no serviço..." />
          </Form.Item>
          {servicoEditando && (
            <Form.Item name="ativo" label="Status" valuePropName="checked">
              <Switch checkedChildren="Ativo" unCheckedChildren="Inativo" />
            </Form.Item>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => setModalServico(false)}>Cancelar</Button>
            <Button type="primary" htmlType="submit">Salvar Serviço</Button>
          </div>
        </Form>
      </Modal>
    <Modal title="Acesso ao Portal" open={modalPortal} onCancel={() => setModalPortal(false)} footer={null} width={500}>
      <Form form={formPortal} layout="vertical" onFinish={salvarAcessoPortal}>
        <Form.Item name="cliente_id" label="Cliente" rules={[{ required: true }]}>
          <Select showSearch optionFilterProp="children" placeholder="Selecione o cliente" onChange={buscarEmailsCliente}>
            {clientes.map(c => <Option key={c.id} value={c.id}>{c.razao_social || c.nome}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item name="email" label="Email de acesso" rules={[{ required: true, type: 'email' }]}>
          <AutoComplete options={emailsSugeridos} placeholder="email@cliente.com.br" filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}>
            <Input />
          </AutoComplete>
        </Form.Item>
        <Form.Item name="senha" label="Senha" rules={[{ required: true, min: 6 }]}>
          <Input.Password placeholder="Mínimo 6 caracteres" />
        </Form.Item>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
          Para redefinir senha de um acesso existente, preencha o mesmo email e defina uma nova senha.
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={() => setModalPortal(false)}>Cancelar</Button>
          <Button type="primary" htmlType="submit">Salvar</Button>
        </div>
      </Form>
    </Modal>

    <Modal title={lote.id ? 'Editar lote de indicador' : 'Novo lote de indicador'}
      open={modalLote} onCancel={() => setModalLote(false)} onOk={salvarLote}
      okText="Salvar" cancelText="Cancelar" width={620}>
      <div style={{ marginBottom: 10 }}>
        <div style={{ fontSize: 12, color: '#888' }}>Tipo</div>
        <Select style={{ width: '100%' }} value={lote.tipo}
          onChange={(v) => setLote({ ...lote, tipo: v, produto: v === 'quimico' ? null : lote.produto })}
          options={[{ value: 'biologico', label: 'Indicador biológico' },
                    { value: 'quimico', label: 'Indicador / integrador químico' }]} />
      </div>
      {campoLote('Fabricante', 'fabricante')}
      {lote.tipo === 'biologico' ? campoLote('Produto', 'produto') : null}
      {campoLote('Lote', 'lote')}
      <div style={{ display: 'flex', gap: 10 }}>
        <div style={{ flex: 1 }}>{campoLote('Fabricação', 'fabricacao', 'date')}</div>
        <div style={{ flex: 1 }}>{campoLote('Validade', 'validade', 'date')}</div>
      </div>
      {lote.tipo === 'biologico' ? (
        <>
          <Divider style={{ margin: '8px 0' }}>Dados do indicador biológico</Divider>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>{campoLote('População', 'populacao')}</div>
            <div style={{ flex: 1 }}>{campoLote('EMPE', 'empe')}</div>
          </div>
          {campoLote('Temperatura', 'temperatura')}
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>{campoLote('Valor D', 'valor_d')}</div>
            <div style={{ flex: 1 }}>{campoLote('Valor Z', 'valor_z')}</div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>{campoLote('Tempo de sobrevivência', 'tempo_sobrevivencia')}</div>
            <div style={{ flex: 1 }}>{campoLote('Tempo de morte', 'tempo_morte')}</div>
          </div>
        </>
      ) : campoLote('Classe / tipo', 'classe')}
      <div style={{ marginTop: 8 }}>
        <Switch checked={lote.ativo !== false} onChange={(v) => setLote({ ...lote, ativo: v })} />
        <span style={{ marginLeft: 8 }}>Lote ativo (aparece na lista do laudo)</span>
      </div>
    </Modal>
    </div>
  );
}

export default Configuracoes;